import React from 'react'
import { cn } from '@/utils'

interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {}

interface FormFieldProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string
  error?: string
  required?: boolean
}

interface FormActionsProps extends React.HTMLAttributes<HTMLDivElement> {
  align?: 'left' | 'center' | 'right'
}

export const Form: React.FC<FormProps> = ({
  children,
  className,
  onSubmit,
  ...props
}) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit?.(e)
  }

  return (
    <form
      className={cn('space-y-4', className)}
      onSubmit={handleSubmit}
      {...props}
    >
      {children}
    </form>
  )
}

export const FormField: React.FC<FormFieldProps> = ({
  children,
  className,
  label,
  error,
  required,
  ...props
}) => {
  return (
    <div className={cn('space-y-2', className)} {...props}>
      {label && (
        <label className="text-sm font-medium text-[var(--text)] leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      {children}
      {error && (
        <p className="text-sm font-medium text-red-500">{error}</p>
      )}
    </div>
  )
}

export const FormActions: React.FC<FormActionsProps> = ({
  children,
  className,
  align = 'right',
  ...props
}) => {
  return (
    <div
      className={cn(
        'flex gap-2 pt-4 border-t border-[var(--border)]',
        {
          'justify-start': align === 'left',
          'justify-center': align === 'center',
          'justify-end': align === 'right',
        },
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export default Object.assign(Form, {
  Field: FormField,
  Actions: FormActions,
}) 